import React, { useState } from 'react';
import { useAppSelector } from '../../../store/store';
import { getCurrentlyWorkingSession } from '../../../store/selector/session.selector';
import { SessionStage } from '../../../interfaces/session.interface';
import PlanEdit from '../plan/PlanEdit';
import PlanView from '../plan/PlanView';
import SwitchPlan from '../plan/SwitchPlan';
import { CampaignTab } from '../../../constants/common';

interface IProps {
    generatingCampaign: boolean;
    setGeneratingCampaign: React.Dispatch<React.SetStateAction<boolean>>;
    setActiveTab: React.Dispatch<React.SetStateAction<CampaignTab>>;
}

const PlanTab = ({ generatingCampaign, setGeneratingCampaign, setActiveTab }: IProps) => {
    const currentlyWorkingSession = useAppSelector(getCurrentlyWorkingSession);
    const [isSwitching, setIsSwitching] = useState(false);

    return (
        <div className="tw-w-full tw-pt-6">
            {currentlyWorkingSession &&
            (generatingCampaign || currentlyWorkingSession.stage === SessionStage.PLAN) ? (
                <>
                    {isSwitching ? (
                        <SwitchPlan setIsSwitching={setIsSwitching} />
                    ) : (
                        <PlanEdit
                            generatingCampaign={generatingCampaign}
                            setGeneratingCampaign={setGeneratingCampaign}
                            setIsSwitching={setIsSwitching}
                            setActiveTab={setActiveTab}
                        />
                    )}
                </>
            ) : (
                <PlanView />
            )}
        </div>
    );
};

export default PlanTab;
